import { WaitForCallbackExpectedFieldType } from ".";

export { defaultWaitForCallbackExpectedField };

const defaultWaitForCallbackExpectedField = {
  fieldName: "",
  fieldType: WaitForCallbackExpectedFieldType.STRING,
  isRequired: false,
  description: "",
};
